import "../style/TextSection.scss"
import { splitText } from "../utils"

function TextSection({ data }) {
  return (
    <div className="section__top">
      <h3>{data?.subtitle}</h3>

      <div className="section__top__right">
        <h1>{splitText(data?.title)}</h1>

        <div
          className="pageLanding__text__separator"
          style={{ margin: "20px 0" }}
        />

        <p>{splitText(data?.description)}</p>
      </div>
    </div>
  )
}

export default TextSection
